import {jsonMember, jsonObject} from "typedjson";

/**
 * Информация о модуле backend-а
 */
@jsonObject()
export class BdpkApiInfo {

  /**
   * Версия API
   */
  @jsonMember({constructor: String})
  apiVersion: string;

  /**
   * Название API
   */
  @jsonMember({constructor: String})
  apiTitle: string;

  /**
   * Описание API
   */
  @jsonMember({constructor: String})
  apiDescription: string;

  /**
   * Тип лицензионного соглашения
   */
  @jsonMember({constructor: String})
  apiLicense: string;

  /**
   * Ссылка на лицензионное соглашение.
   */
  @jsonMember({constructor: String})
  apiLicenseUrl: string;

  /**
   * Название компании-разработчика
   */
  @jsonMember({constructor: String})
  apiContributorName: string;

  /**
   * Электронная почта компании-разработчика.
   */
  @jsonMember({constructor: String})
  apiContributorEmail: string;

  /**
   * Ссылка на сайт компании-разработчика.
   */
  @jsonMember({constructor: String})
  apiContributorUrl: string;

  /**
   * Ветка с которой была собрана сборка приложения.
   */
  @jsonMember({constructor: String})
  branch: string;

  /**
   * ID последнего коммита.
   */
  @jsonMember({constructor: String})
  commitId: string;

  /**
   * Дата и время последнего коммита.
   * WARNING: не по формату
   */
  @jsonMember({constructor: String})
  commitDateTime: string;
}
